type EnumLike = { [key: string]: string };

export const getOptionsFromEnum = (enumObj: EnumLike) => {
  return Object.entries(enumObj).map(([_key, value]) => ({
    label: value,
    value: value,
  }));
};
